import _ from 'lodash';
import { SessionView } from './types';
import {
  ACTIVE_VERSION,
  AGENT_ID_PLACEHOLDER,
  SESSION_VIEW_TYPE,
  DEFAULT_VIEW_SETTINGS,
} from './constants';
import { SESSION_STATUS } from '@/constants';

export const useSessionViewsMigrations = () => {
  const migrateSessionFilter = (sessionFilter: any = {}) => {
    const {
      tags,
      hideOngoing,
      hideClaimed,
      hideClaimedByAnother,
      hideNeedsAction,
      showClosed,
    } = sessionFilter;

    const status = _.compact([
      !hideOngoing ? SESSION_STATUS.ONGOING : undefined,
      !hideClaimed ? SESSION_STATUS.CLAIMED : undefined,
      showClosed ? SESSION_STATUS.CLOSED : undefined,
    ]);

    const userId = hideClaimedByAnother && !hideClaimed
      ? AGENT_ID_PLACEHOLDER
      : undefined;

    return {
      tags,
      status,
      claimedBy: userId ?? '',
      claimedByHistory: '',
      needsAction: !hideNeedsAction,
    };
  };

  /** Update settings to the latest version while preserving legacy changes */
  const migrateSessionViewSettings = (item: SessionView) => {
    if (item.version === ACTIVE_VERSION) {
      return item;
    }

    const { settings } = item;
    const { sessionFilter } = item.settings;
    const defaultType = settings.display?.mode !== 'grouped_by_contact' && settings.display?.groupByContact === false
      ? SESSION_VIEW_TYPE.SESSIONS
      : SESSION_VIEW_TYPE.GROUP_BY_CONTACT;

    const display = {
      ..._.omit(settings.display, ['groupByContact', 'mode']),
      type: settings.display?.type || defaultType,
      _mode: settings.display?.mode,
      _groupByContact: settings.display?.groupByContact,
    };

    const update = {
      ...DEFAULT_VIEW_SETTINGS,
      ..._.omit(settings, ['conversations', 'display', 'sessionFilter']),
      conversations: migrateSessionFilter(sessionFilter),
      display,
      _sessionFilter: settings.sessionFilter,
    };

    const common = {
      version: ACTIVE_VERSION,
      isEnabled: true,
    };

    return JSON.parse(JSON.stringify({ ...item, ...common, settings: update })) as SessionView;
  };

  const migrateSessionViews = async () => {};

  return {
    migrateSessionViewSettings,
    migrateSessionViews,
  };
};
